const baseurl = "https://api-dev.fusioninnovative.com";

export const CONTACT_US = baseurl + "/contactUs";
export const BECOME_PARTNER = baseurl + "/becomePartner"